import { ExpositionModel, expositionModelInitial } from './ExpositionModel';
import { JournalistModel, journalistModelInitial } from './JournalistModel';
import { KeywordModel, keywordModelInitial } from './KeywordModel';
import { SourceModel, sourceModelInitial } from './SourceModel';

export type BatchModel = JournalistModel | KeywordModel | SourceModel | ExpositionModel;

export const batchModelInitial: BatchModel = {
    ...journalistModelInitial,
    ...keywordModelInitial,
    ...sourceModelInitial,
    ...expositionModelInitial
};